module.exports = __webpack_public_path__ + "images/application/promo/comic-book-dunning@2x-16e1bf23.png";